import React from "react";
import { theme } from "../theme/theme";

export const Quote = () => (
  <svg
    className="Quote"
    width="41"
    height="36"
    viewBox="0 0 41 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.5401 35.7401H25.0701C23.7101 29.8468 23.0301 24.6335 23.0301 20.1001C23.0301 7.29347 28.8101 0.890137 40.3701 0.890137V8.37014C34.9301 8.37014 32.2101 11.3168 32.2101 17.2101V21.1201H40.5401V35.7401ZM17.5901 35.7401H2.12008C0.760078 29.8468 0.0800781 24.6335 0.0800781 20.1001C0.0800781 7.29347 5.86008 0.890137 17.4201 0.890137V8.37014C11.9801 8.37014 9.26008 11.3168 9.26008 17.2101V21.1201H17.5901V35.7401Z"
      fill="#E9C8C3"
    />
  </svg>
);

export const CardArrow = () => (
  <svg
    className="CardArrow"
    width="85"
    height="30"
    viewBox="0 0 85 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.4142 16.4142C85.1953 15.6332 85.1953 14.3668 84.4142 13.5858L71.6863 0.857864C70.9052 0.0768158 69.6389 0.0768158 68.8579 0.857864C68.0768 1.63891 68.0768 2.90524 68.8579 3.68629L80.1716 15L68.8579 26.3137C68.0768 27.0948 68.0768 28.3611 68.8579 29.1421C69.6389 29.9232 70.9052 29.9232 71.6863 29.1421L84.4142 16.4142ZM0 17H83V13H0V17Z"
      fill="white"
    />
  </svg>
);

export const Lightning = () => (
  <svg
    className="Lightning"
    width={122}
    height={135}
    viewBox="0 0 122 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_217_357)">
      <path
        opacity="0.5"
        d="M74 134.97C100.51 134.97 122 113.48 122 86.9702C122 60.4605 100.51 38.9702 74 38.9702C47.4903 38.9702 26 60.4605 26 86.9702C26 113.48 47.4903 134.97 74 134.97Z"
        fill="#E9C8C3"
      />
      <path
        d="M13.5 29C20.9558 29 27 22.9558 27 15.5C27 8.04416 20.9558 2 13.5 2C6.04416 2 0 8.04416 0 15.5C0 22.9558 6.04416 29 13.5 29Z"
        fill="#F9FACC"
      />
      <path
        d="M96.1095 56.4602L36.3796 129.24C35.9998 129.72 35.5165 130.108 34.9659 130.374C34.4152 130.641 33.8113 130.78 33.1995 130.78C32.5621 130.778 31.9337 130.63 31.3615 130.35C30.7893 130.069 30.2884 129.662 29.8965 129.159C29.5046 128.656 29.2319 128.071 29.099 127.448C28.9662 126.824 28.9766 126.179 29.1296 125.56L40.1296 83.3002L40.0096 83.1302H11.6696C11.122 83.1276 10.5802 83.0172 10.0752 82.8052C9.57032 82.5932 9.1121 82.2838 8.72673 81.8947C8.34137 81.5057 8.03641 81.0445 7.82927 80.5376C7.62214 80.0306 7.51695 79.4878 7.51958 78.9402C7.52758 77.9857 7.85889 77.0621 8.45952 76.3202L68.1895 3.54023C68.7838 2.79833 69.6174 2.28597 70.5477 2.09079C71.478 1.89561 72.4473 2.02973 73.2896 2.47024C74.1428 2.89298 74.8233 3.59821 75.2153 4.46601C75.6072 5.33381 75.6864 6.31059 75.4395 7.23024L64.4395 49.4802L64.5695 49.6502H92.8896C93.4385 49.645 93.9831 49.7479 94.4922 49.9531C95.0014 50.1583 95.4651 50.4617 95.857 50.8462C96.2488 51.2306 96.5611 51.6885 96.776 52.1936C96.991 52.6988 97.1043 53.2413 97.1095 53.7902C97.0986 54.7698 96.7447 55.7145 96.1095 56.4602V56.4602Z"
        stroke="#3B2A5C"
        strokeWidth={4}
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_217_357">
        <rect width={122} height="134.97" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Arrow = ({ className = "Arrow" }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
      fill={theme.primary}
    />
  </svg>
);

export const Logo = ({ className }) => (
  <svg
    className={className ?? "Logo"}
    width="130px"
    viewBox="0 0 217 91"
    fill="none"
  >
    <path
      d="M79.5998 54.37C77.6298 57.13 75.2898 58.75 72.2598 58.75C67.5898 58.75 66.1198 55.32 66.1198 50.55V30.55H56.2598V52.46C56.2598 62.74 61.8298 67.28 68.8398 67.28C74.4098 67.28 77.4998 64.91 79.5998 62.45V66.4H89.4598V30.55H79.5998V54.37Z"
      fill="#3F2860"
    />
    <path
      d="M103.77 12.31C100.48 12.31 97.7002 14.5 97.7002 17.96C97.7002 21.84 100.48 24.04 103.77 24.04C106.55 24.04 109.33 21.85 109.33 17.96C109.33 14.5 106.55 12.31 103.77 12.31Z"
      fill="#3F2860"
    />
    <path d="M108.45 30.55H98.5898V66.4H108.45V30.55Z" fill="#3F2860" />
    <path
      d="M141.71 31.82C140.36 30.64 137.92 29.67 134.58 29.67C123.04 29.67 115.27 37.56 115.27 48.87C115.27 59.78 121.53 67.03 131.79 67.03C136.41 67.03 139.28 65.22 141.71 62.77V66.39H151.57V2.25H141.71V31.82V31.82ZM141.71 54.41C139.71 56.41 137.2 57.95 133.96 57.95C129.26 57.95 125.6 54.48 125.6 48.32C125.6 41.93 129.96 38.38 135.19 38.38C137.58 38.38 139.77 39.15 141.7 40.46V54.41H141.71Z"
      fill="#3F2860"
    />
    <path
      d="M201.61 29.91C197.31 29.91 192.38 31.64 190.31 33.78V30.55H180.51V66.4H190.31V41.94C192.46 39.79 196.26 38.51 199.36 38.51C203.86 38.51 206.89 41.22 206.89 46.95V66.39H216.75V45.37C216.76 34.13 210.37 29.91 201.61 29.91Z"
      fill="#3F2860"
    />
    <path
      d="M26.44 58.43C26.41 58.43 26.39 58.43 26.36 58.43H24.83C20.7 58.43 20.07 55.27 20.07 54.21C20.07 52.32 20.57 50.76 21.73 49.77C23.32 50.07 25 50.23 26.74 50.23C39.64 50.23 48.66 42.3 48.66 31.51C48.66 28.13 47.93 24.97 46.48 22.22L51.94 20.19V12.53L40.7 15.86C37.19 13.53 32.53 12.16 26.75 12.16C12.56 12.16 4.83 21.38 4.83 31.52C4.83 37.81 8.31 43.5 14.02 46.91C12.06 48.81 10.99 51.32 10.99 54.21C10.99 56.71 11.75 58.66 12.96 60.18C5.62 62.36 0 66.76 0 74.56C0 89.4 18.7 90.69 26.44 90.69C32.89 90.69 53.52 89.4 53.52 74.56C53.52 59.08 32.67 58.43 26.44 58.43ZM26.8 21.19C33.56 21.19 38.48 25.98 38.48 31.96C38.48 37.35 33.56 41.54 26.8 41.54C20.04 41.54 15.12 37.35 15.12 31.96C15.11 25.98 20.03 21.19 26.8 21.19ZM26.53 81.81C16.4 81.81 10.45 79.02 10.45 74.54C10.45 72.3 11.64 67.27 26.53 67.27C40.81 67.27 43.21 72.3 43.21 74.54C43.21 77.33 40.15 81.81 26.53 81.81Z"
      fill="#3F2860"
    />
    <path
      d="M166.52 12.31C163.23 12.31 160.45 14.5 160.45 17.96C160.45 21.84 163.23 24.04 166.52 24.04C169.3 24.04 172.08 21.85 172.08 17.96C172.08 14.5 169.3 12.31 166.52 12.31Z"
      fill="#3F2860"
    />
    <path d="M171.2 30.55H161.34V66.4H171.2V30.55Z" fill="#3F2860" />
  </svg>
);

export const QuoteIcon = (props) => (
  <svg
    width="80"
    height="60"
    viewBox="0 0 88 60"
    fill="#eae5e5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.98 0H6.18727C2.77014 0 0 2.79644 0 6.24603V30.9291C0 34.3787 2.77014 37.1752 6.18727 37.1752H12.204C14.2392 37.1752 16.1118 38.2974 17.0864 40.101C17.7925 41.4078 17.9571 42.9381 17.5451 44.3673C16.2347 48.9134 13.3809 58.9105 13.3809 59.7512C13.3809 60.8424 14.5736 61.2562 15.3564 60.8424C16.1391 60.4285 29.2591 46.3561 33.2845 41.728C37.31 37.0999 38.1673 34.3908 38.1673 29.4617V6.24603C38.1673 2.79644 35.3971 0 31.98 0Z"
      fill="current-color"
    />
    <path
      d="M31.98 0H6.18727C2.77014 0 0 2.79644 0 6.24603V30.9291C0 34.3787 2.77014 37.1752 6.18727 37.1752H12.204C14.2392 37.1752 16.1118 38.2974 17.0864 40.101C17.7925 41.4078 17.9571 42.9381 17.5451 44.3673C16.2347 48.9134 13.3809 58.9105 13.3809 59.7512C13.3809 60.8424 14.5736 61.2562 15.3564 60.8424C16.1391 60.4285 29.2591 46.3561 33.2845 41.728C37.31 37.0999 38.1673 34.3908 38.1673 29.4617V6.24603C38.1673 2.79644 35.3971 0 31.98 0Z"
      fill="current-color"
      transform="translate(46 0)"
    />
  </svg>
);
